import * as React from 'react'
import { Notification } from '@lacedltd/laced-components'
import tokens from '@lacedltd/design-tokens'
import { useUser, useUserStripeAccount, useLocale, useTranslation } from 'hooks'
import { withTranslations } from 'helpers'

/**
 * Component for displaying a banner that prompts the user to complete Stripe account verification.
 * @param {StripeVerificationBannerProps} props
 * @returns {JSX.Element | null}
 */
const StripeVerificationBanner = ({ button = true, text }) => {
  const { t } = useTranslation()
  const { user: userInfo, fetching: gettingUserInfo } = useUser()
  const { account, fetching: fetchingStripeAccount } = useUserStripeAccount()
  const [hasCompleted, setHasCompleted] = React.useState(true)
  const { localiseUrl } = useLocale()

  React.useEffect(() => {
    if (userInfo && account && !gettingUserInfo && !fetchingStripeAccount) {
      setHasCompleted(
        !!(
          userInfo?.seller_profile_complete === true &&
          ['verified', 'pending'].includes(account?.verification_status)
        )
      )
    } else {
      setHasCompleted(false)
    }
  }, [userInfo, account, gettingUserInfo, fetchingStripeAccount])

  return !hasCompleted ? (
    <Notification
      text={text}
      variant="warning"
      cta={
        button
          ? {
              text: t('shared.verify_account'),
              href: localiseUrl('/account/selling/verify')
            }
          : undefined
      }
      style={{ marginBottom: tokens.spacing[5] }}
    />
  ) : null
}

/**
 * @typedef {Object} StripeVerificationBannerProps
 * @property {boolean} [button]
 * @property {string} text
 */

export default withTranslations(StripeVerificationBanner)
